import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { useTheme } from "@/contexts/ThemeContext";

export function Logo({ size = 34, withText = true, subtitle = false }) {
  const { t } = useI18n();
  const theme = useTheme();
  const dark = theme?.isDark;
  const sfx = dark ? "-dark" : "";
  return (
    <Link to="/" className="flex items-center leading-none logo-anim" aria-label={t("brand.name")}>
      <img src={`/next-circle${sfx}.png`} alt="" aria-hidden="true" className="logo-circle object-contain w-auto" style={{ height: size }} />
      <img src={`/next-arrow${sfx}.png`} alt="" aria-hidden="true" className="logo-arrow object-contain w-auto" style={{ height: size }} />
      <img src={`/next-word${sfx}.png`} alt={t("brand.name")} className="logo-word object-contain w-auto" style={{ height: size }} />
    </Link>
  );
}
